export default defineNuxtRouteMiddleware( async () => {
  const basketStore = useBasketStore();
  const auth = useAuthStore();
  const resource = useContentDeliveryResource();

  if ( basketStore.basketEmpty ) {
    const { data: selectSubscription } = await resource.getByTypeSingle( "selectSubscription" );

    if ( !selectSubscription.value ) {
      throw createError( {
        statusCode: 400,
        message: "Cannot access checkout page, no subscription selected",
        fatal: true,
      } );
    }

    return navigateTo( selectSubscription.value?.route.path );
  } else {
    // Retry fetching auth details if the address is not yet available or marked as not found
    const maxAttempts = 10;
    const delayMs = 200; // short delay between attempts

    for ( let attempt = 1; attempt <= maxAttempts; attempt++ ) {
      const currentAddress = auth.webAccount?.address;
      const hasValidAddress = !!currentAddress && currentAddress.address1 !== "NO ADDRESS FOUND";

      if ( hasValidAddress ) {
        break; // Address is available, proceed
      }

      try {
        await auth.refreshAuthDetails( true );
      } catch {
        // ignore refresh errors during retry; will attempt again shortly
      }

      // If not last attempt, wait a bit before retrying
      if ( attempt < maxAttempts ) {
        await new Promise( resolve => setTimeout( resolve, delayMs ) );
      }
    }

    const { type, ...address } = auth.webAccount?.address ?? {};

    if ( address ) {
      await basketStore.setAddress( {
        type: "Invoice",
        address: {
          ...address,
          type: "Invoice",
        },
      } );
    } else {
      throw createError( {
        statusCode: 500,
        message: "Cannot access checkout page, unable to set address",
        fatal: true,
      } );
    }
  }
} );
